<template>
  <v-btn
    depressed
    color="primary"
    height="52"
    :href="href"
    :block="isMobile"
    class="branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1 lpu-doctors-show-all-link"
    data-qa="lpu_doctors_list_show_all"
  >
    {{ label }}
  </v-btn>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'

defineProps<{
  href: string
  label: string
}>()

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
.lpu-doctors-show-all-link:not(.v-btn--block) {
  align-self: center;
}
</style>
